import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, finalize, map, throwError } from 'rxjs';
import { IdleControlService } from './idle-control.service';
import { OneQmsAuthService } from './core/auth/one-qms-auth.service';
import { Router } from '@angular/router';
import { SuccessSnackbarComponent } from './support/success-snackbar/success-snackbar.component';
import { messageService } from './message.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class OneqmsInterceptorInterceptor implements HttpInterceptor {

  constructor(
    private readonly router: Router,
    private readonly snackBar: MatSnackBar,
    private readonly message: messageService,
    private readonly idleControl: IdleControlService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const excludedUrls = ['https://oneqms-printer', 'api.ipify.org', 'checkip.amazonaws.com'];

    const isExcluded = excludedUrls.some(url => request.url.includes(url));

    if (isExcluded) { return next.handle(request); }

    const timezone = localStorage.getItem('timezone');
    const tokenId = localStorage.getItem('tokenId');

    const headers: Record<string, string> = {};
    if (timezone) headers['timezone'] = timezone;
    if (tokenId) headers['tokenId'] = tokenId;

    const clonedRequest = request.clone({
      withCredentials: true,
      setHeaders: headers
    });

    const skipIdleControl = request.url.includes('timezones/getUtcTime') || request.url.includes('session/validate') || request.url.includes('session/refresh') || request.url.includes('session/remainingTime');

    if (!skipIdleControl) {
      this.idleControl.apiStarted();
    }

    return next.handle(clonedRequest).pipe(

      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.body) {
            if (
              event.body === 'Transaction silently rolled back because it has been marked as rollback-only' ||
              event.body.error?.includes('ORA-20002')
            ) {
            }
          }
        }
        return event;
      }),

      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          const backendMessage = error.error?.message;

          if (backendMessage === 'Session invalid' || error.error?.error === 'Unauthorized') {
            setTimeout(() => this.showSnackBar("Session Overridden!", 'N'));
            this.router.navigate(['/login']);
          }
        }
        return throwError(() => error);
      }),

      finalize(() => {
        if (!skipIdleControl) {
          this.idleControl.apiFinished();
        }
      }),
    );
  }

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    let messageType: string;

    if (type === 'S') {
      messageType = 'Success';
    } else if (type === 'E') {
      messageType = 'Error';
    } else {
      messageType = 'Notice';
    }

    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: messageType,
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }
}
